// extracted by mini-css-extract-plugin
export default {"button":"styles_button__C3brN","logout":"styles_logout__DWZHK","login":"styles_login__OrJz7"};